import { createFileRoute } from "@tanstack/react-router"
import { RefundPolicyPage } from "@/routes/refund-policy"

export const Route = createFileRoute("/$lang/refund-policy")({
  component: RefundPolicyPage,
})
